import { gql } from "@apollo/client";

export const GET_CANAL_BY_INSTITUCION = gql`
query GetCanalByInstitucion($codigoInstitucion: String!, $idTipoModulo: Int!)
{
    canalByInstitucion(codigoInstitucion: $codigoInstitucion, idTipoModulo: $idTipoModulo)
    {
        success
        error
        valorEsperado {
            idCanal
            descripcion
            detalle
            codigoInstitucion
        }
    }
}
`;